export default {
    "lang": "葡萄牙语",
    "application": {
        "name": "Sistema de Publicação de Informações"
    },
    "ajaxTip": {
        "success": "Sucesso",
        "error": "Falha",
        "noAccess": "Sem permissão para acessar este recurso",
        "notFound": "O recurso acessado não existe",
        "serverBusy": "Servidor ocupado",
        "timeOut": "Tempo esgotado"
    },
    "menu": {
        "home": "Página Inicial",
        "template": "Gerenciamento de Modelos",
        "program": "Gerenciamento de Programas",
        "playplan": "Plano de Reprodução",
        "device": "Gerenciamento de Dispositivos",
        "source-material": "Gerenciamento de Materiais",
        "material": "Materiais",
        "checkManage": "Gerenciamento de Avaliações",
        "setting": "Configurações",
        "usercenter": "Centro do Usuário",
        "adminManage": "Gerenciamento de Dispositivos",
        "schedule": "Tarefas Pendentes",
        "capitalassets": "Gerenciamento de Ativos",
        "modifyPassword": "Alterar Senha",
        "logout": "Sair da Conta",
        "add": "Adicionar",
        "edit": "Editar",
        "delete": "Excluir",
        "view": "Visualizar",
        "menu_1": "Página Inicial",
        "menu_2": "Gerenciamento de Dispositivos",
        "menu_3": "Editar (Configurações Avançadas - Edição Básica - Alterar Rede)",
        "menu_4": "Comandos Imediatos",
        "menu_5": "Editar (Transferir Departamento)",
        "menu_6": "Estratégia",
        "menu_7": "Configurações de Volume",
        "menu_8": "Configurações de Brilho",
        "menu_9": "Configurações de Download",
        "menu_10": "Configurações de Suspensão",
        "menu_11": "Propriedades do Dispositivo",
        "menu_12": "Editar/Adicionar",
        "menu_13": "Gerenciamento de Programas",
        "menu_14": "Histórico de Publicação",
        "menu_15": "Excluir (Lote/Individual)",
        "menu_16": "Programas em Publicação",
        "menu_17": "Agrupamento",
        "menu_19": "Lista de Programas",
        "menu_20": "Edição de Conteúdo",
        "menu_21": "Copiar Programa",
        "menu_23": "Publicar Programa",
        "menu_24": "Gerenciamento de Materiais",
        "menu_25": "Enviar",
        "menu_28": "Publicação Rápida",
        "menu_29": "Gerenciamento de Modelos",
        "menu_30": "Modelos Públicos",
        "menu_31": "Usar Agora",
        "menu_32": "Meus Modelos",
        "menu_33": "Publicar em Modelos Públicos",
        "menu_35": "Histórico de Compartilhamento",
        "menu_36": "Gerenciamento de Auditoria",
        "menu_37": "Auditoria de Programas",
        "menu_38": "Auditoria (Aprovar/Rejeitar)",
        "menu_39": "Auditoria de Materiais",
        "menu_41": "Histórico de Auditoria (Operador)",
        "menu_42": "Histórico de Auditoria (Auditor)",
        "menu_43": "Visualizar Quantidade de Aprovações",
        "menu_44": "Gerenciamento de Organização",
        "menu_45": "Gerenciamento de Logs",
        "menu_46": "Logs de Reprodução",
        "menu_47": "Logs de Publicação",
        "menu_48": "Logs de Erros",
        "menu_49": "Logs de Operações",
        "menu_50": "Logs de Arquivos",
        "menu_51": "Logs de Login",
        "menu_52": "Aprovação de Conteúdo",
        "menu_53": "Espaço de Armazenamento",
        "menu_54": "Estrutura Organizacional",
        "menu_55": "Permissões de Função",
        "menu_56": "Autorização",
        "menu_57": "Visualizar (Permissões de Autorização)",
        "menu_58": "Membros da Organização",
        "menu_60": "Redefinir Senhas de Usuários Subordinados",
        "menu_61": "Gerenciamento de Ativos",
        "menu_62": "Meu Saldo",
        "menu_63": "Visualizar (Detalhes de Fundos)",
        "menu_64": "Meu Uso de Dados",
        "menu_65": "Visualizar (Detalhes de Uso de Dados)",
        "menu_66": "Comprar Uso de Dados",
        "menu_67": "Minha Capacidade",
        "menu_68": "Meus Dispositivos",
        "menu_69": "Detalhes do Pedido",
        "menu_70": "Visualizar (Recarregar)",
        "menu_71": "Visualizar (Modelos Comprados)",
        "menu_72": "Visualizar (Uso de Dados Comprado)",
        "menu_73": "Outras Permissões",
        "menu_74": "Visualizar (Estatísticas de Materiais e Programas)",
        "menu_75": "Visualizar (Ativos)",
        "menu_76": "Visualizar (Uso de Dados em Nuvem/Estatísticas)",
        "menu_77": "Visualizar (Estatísticas de Dispositivos Online)"
    },
    "login": {
        "terminalServiceSystem": "Sistema de Serviços de Terminal Inteligente",
        "accountLogin": "Login com Conta",
        "register": "Cadastrar",
        "accountLoginTip": "Já tem uma conta? Faça login",
        "scanQRCode": "Por favor, escaneie o código QR",
        "readAndAgree": "Li e concordo com",
        "readAndAgreeLink": "Termos de Serviço do Usuário",
        "readAndAgreeAgreement": "Por favor, leia e concorde com os Termos de Serviço do Usuário",
        "forgetpassword": "Esqueceu a senha?",
        "resetpassword": "Redefinir Senha",
        "phoneEmptyTip": "Por favor, insira o número de telefone",
        "nextStep": "Próximo Passo",
        "title": "Bem-vindo ao Login",
        "submit": "Login",
        "userName": "Conta",
        "password": "Senha",
        "userNameEmptyTip": "Por favor, insira a conta",
        "passwordEmptyTip": "Por favor, insira a senha",
        "passwordFormatTip": "Por favor, insira um formato de senha válido",
        "passwordIsOk": "Por favor, insira a senha de confirmação",
        "passwordSign": "Por favor, insira a senha",
        "codeTip": "Por favor, insira o código de verificação",
        "phone": "O número de telefone não pode estar vazio",
        "code": "O código de verificação não pode estar vazio",
        "nickname": "O nome da empresa não pode estar vazio",
        "pass": "A senha não pode estar vazia",
        "pwdMessage": "A senha deve ter entre 8 e 20 caracteres, não pode conter espaços e deve incluir 3 dos seguintes tipos: letras maiúsculas, letras minúsculas, números, caracteres especiais",
        "pwdMessage01": "Por favor, insira uma senha com letras e números, no mínimo 8 caracteres",
        "pwdMessage02": "A senha deve ter entre 8 e 20 caracteres",
        "pwdMessage03": "A senha não pode conter espaços",
        "pwdMessage04": "A senha deve incluir 3 dos seguintes tipos: letras maiúsculas, letras minúsculas, números, símbolos",
        "newpassempty": "A nova senha não pode estar vazia",
        "newpass": "As duas senhas não coincidem",
        "getcode": "Obter Código de Verificação",
        "format": "Formato de número de telefone inválido",
        "chongfa": "Reenviar em {seconds} segundos",
        "isSend": "Enviado",
        "noregister": "Não tem uma conta? Cadastre-se agora",
        "Mobile": "Número de Telefone",
        "verificationcode": "Código de Verificação",
        "petname": "Apelido",
        "Quickregistration": "Cadastro Rápido",
        "xiugaimima": "Alterar Senha",
        "jiumima": "Senha Antiga",
        "xinmima": "Nova Senha",
        "zaicishuruxinmima": "Repita a Nova Senha",
        "xiugaichenggong": "Alteração bem-sucedida",
        "xiugaishoujihao": "Alterar Número de Telefone",
        "dengluzhanghao": "Conta de Login",
        "gongsiid": "ID da Empresa",
        "yonghunicheng": "Apelido do Usuário",
        "chuangjianshijian": "Data de Criação",
        "gongsimingcheng": "Nome da Empresa",
        "denglumima": "Senha de Login",
        "jianyi": "Recomenda-se usar uma senha com combinação de letras e números",
        "shezhimima": "Definir Senha",
        "shezhishoujihao": "Alterar/Definir Número de Telefone",
        "yibangding": "Vinculado",
        "weibangding": "Não Vinculado",
        "zhanghuanquan": "Segurança da Conta",
        "yonghuxinxi": "Informações do Usuário",
        "zhuceSucMsg": "Parabéns, cadastro realizado com sucesso!",
        "verificationcodeSucMsg": "Código de verificação enviado com sucesso!",
        "requiredIsEmpty": "Campos obrigatórios não podem estar vazios!",
        "emailObj": {
            "title": "E-mail",
            "tit": "Login com E-mail",
            "tip": "Por favor, insira o endereço de e-mail",
            "formatTip": "Por favor, insira um formato de e-mail válido"
        },
        "phoneObj": {
            "title": "Telefone",
            "tit": "Login com Telefone",
            "tip": "Por favor, insira o número de telefone",
            "formatTip": "Por favor, insira um formato de número de telefone válido"
        },
        "emailOrPhoneObj": {
            "title": "E-mail ou Telefone",
            "tit": "Login com E-mail ou Telefone",
            "tip": "Por favor, insira o e-mail ou número de telefone",
            "formatTip": "Por favor, insira um formato de e-mail ou telefone válido"
        },
        "wechatObj": {
            "title": "WeChat",
            "tit": "Login com WeChat"
        },
        "googleObj": {
            "title": "Google",
            "tit": "Login com Google"
        },
        "confirm": "Confirmar",
        "confirmSubmit": "Enviar Confirmação",
        "cancel": "Cancelar",
        "close": "Fechar",
        "bindSucMsg": "Vinculação bem-sucedida",
        "toContinueBindAccount": "Continuar para concluir a vinculação da conta terceira",
        "bindTip01": "Não tem uma conta? Crie uma",
        "bindTip02": "Já tem uma conta",
        "bindTip03": "A conta terceira atual não está vinculada a uma conta da plataforma. Por favor, vincule uma conta existente ou cadastre e vincule uma nova conta para fazer login rapidamente na próxima vez.",
        "bindTip04": "Vincular conta existente",
        "bindTip05": "Cadastrar e vincular nova conta",
        "bindTip06": "Você foi autorizado por terceiros. Complete as seguintes informações de login para concluir a vinculação",
        "bindSubmit": "Enviar Vinculação",
        "enterAccountTip": "Por favor, insira o nome da conta",
        "RegisterAndBind": "Cadastrar e Vincular",
        "loginErr": "Nome de usuário ou senha incorretos!",
        "usercenter": "Centro do Usuário",
        "pleaseInputName": "Por favor, insira o nome",
        "operationSuccess": "Operação bem-sucedida!",
        "edit": "Editar",
        "xiugai": "Alterar",
        "userData": "Perfil Pessoal",
        "changePassword": "Alteração de Senha",
        "account": "Conta",
        "userName01": "Nome de Usuário",
        "phoneNumber": "Número de Telefone",
        "role": "Cargo",
        "createTime": "Data de Criação",
        "genghuang": "Trocar",
        "bangding": "Vincular",
        "unbind": "Desvincular",
        "plesaseSelectBindingType": "Por favor, selecione o tipo de vinculação",
        "pleaseConfirmCont": "Por favor, confirme que leu este conteúdo",
        "confirmReadCont": "Li este conteúdo",
        "frequentTip": "Operação muito frequente, tente obter novamente mais tarde!",
        "zhuxiaoBtn": "Cancelar Conta",
        "zhuxiaoTitle": "Cancelamento de Conta",
        "querenZhuxiao": "Confirmar Cancelamento",
        "jiXu": "Continuar",
        "sendCodeBtn": "Enviar Código de Verificação",
        "passwordIsNotOldPassword": "A senha de confirmação difere da nova senha inserida",
        "passwordIsOldPassword": "A nova senha é igual à senha antiga",
        "passFormatError": "Por favor, insira um formato de senha válido",
        "oldPassWord": "Senha Antiga",
        "newPassWord": "Nova Senha",
        "inputPlaceholder": "Por favor, insira",
        "confirmPassword": "Confirmar Senha",
        "zhuxiaoTip": `
            1、O cancelamento da conta é uma operação irreversível. Uma vez cancelada, você não poderá mais fazer login e usar esta conta ou contas terceiras registradas/login através desta conta. Faça backup das informações e dados relacionados à conta por conta própria.
            2、Antes de registrar esta conta, certifique-se de ter esvaziado todos os ativos e que não existem controvérsias; uma vez cancelada, esta conta será considerada como uma renúncia à propriedade de todos os ativos e direitos dentro da conta, sem possibilidade de recuperação.
            3、Se o número de telefone registrado tiver 3 contas canceladas acumuladamente, este número não poderá registrar novas contas nem vincular a qualquer outra conta.
        `
    },
    "home": {
        "title": "Página Inicial",
        "quickOperation": "Operações Rápidas",
        "addDevice": "Adicionar Dispositivo",
        "publishProgram": "Publicar Programa",
        "publishMaterial": "Publicar Material",
        "makeProgram": "Criar Programa",
        "uploadMaterial": "Fazer Upload de Materiais",
        "todayData": "Dados de Hoje (atualizado a cada hora)",
        "playNumChart": "Estatísticas de Número de Reproduções",
        "deviceOnlineStatus": "Status de Conexão dos Dispositivos",
        "onLineDevice": "Dispositivos Online",
        "unLineDevice": "Dispositivos Offline",
        "programPlayTime": "Estatísticas de Duração de Reprodução de Programas",
        "downloadSoft": "Download de Software",
        "adminApp": "Aplicativo para Usuários Móveis",
        "playerApp": "Terminal de Reprodução de Publicação de Informações",
        "downloadAdminApp": "Clique para baixar o aplicativo do usuário",
        "downloadPlayerApp": "Clique para baixar o aplicativo de reprodução",
        "aboutUs": "Sobre Nós",
        "userManual": "Manual do Usuário",
        "message": "Deixar uma Mensagem"
    },
    "device": {
        "inputPlaceholder": "Por favor, insira",
        "selectPlaceholder": "Por favor, selecione",
        "osTypeStr": "Sistema do Terminal",
        "onLineStatus": "Status de Conexão",
        "dpi": "Resolução",
        "companyDeptIdName": "Organização Pertencente",
        "deviceGroupIdName": "Grupo Pertencente",
        "editOrMove": "Editar/Mover",
        "loanOriginationFee": "Taxa de Emissão de Empréstimo",
        "strategyInfoLook": "Visualizar Informações da Estratégia",
        "programLook": "Visualizar Programas",
        "addEquipments": "Adicionar Dispositivos",
        "luminanceSet": "Controle de Luminosidade",
        "terminal": "Configurações do Terminal",
        "transferCompany": "Transferir Departamento",
        "releasedProgram": "Publicar Programa",
        "screenshot": "Captura de Tela",
        "changeGroup": "Alterar Grupo",
        "defaultGroup": "Grupo Padrão",
        "operation": "Operação",
        "edit": "Editar",
        "saveEdit": "Salvar Edição",
        "add": "Adicionar",
        "save": "Salvar",
        "setting": "Configurações",
        "program": "Programa",
        "unbind": "Desvincular",
        "sleep": "Hibernar",
        "wakeup": "Acordar",
        "restart": "Reiniciar",
        "shutdown": "Desligar",
        "reportLog": "Relatar Logs",
        "clearPlayData": "Limpar Dados do Terminal de Reprodução",
        "offlineWarn": "Este dispositivo está offline, tente novamente quando estiver online!",
        "confirmUnbind": "Confirmar Desvinculação",
        "confirmReset": "Confirmar Limpeza",
        "confirmDelete": "Confirmar Exclusão",
        "delete": "Excluir",
        "cancelDelete": "Cancelar Exclusão",
        "confirmResetSuccess": "Limpeza bem-sucedida",
        "confirm": "Confirmar",
        "cancel": "Cancelar",
        "operationSuccess": "Operação bem-sucedida",
        "unbindSuccess": "Desvinculação bem-sucedida",
        "pleaseSelectDevice": "Por favor, selecione um dispositivo",
        "pleaseSelectOnlineDevice": "Por favor, selecione um dispositivo online",
        "confirmMixOperation": "A seleção inclui dispositivos offline, esta configuração não terá efeito neles. Confirmar continuação da operação?",
        "pleaseSelectDate": "Por favor, selecione uma data",
        "reportSuccess": "Relatório enviado com sucesso",
        "deviceSetting": "Configurações do Dispositivo",
        "default": "Padrão",
        "all": "Todos",
        "deviceList": "Lista de Dispositivos",
        "addDevice": "Adicionar Dispositivo",
        "department": "Organização de Departamentos",
        "deviceType": "Resolução",
        "osType": "Sistema do Terminal",
        "onlineState": "Status de Conexão",
        "online": "Online",
        "offline": "Offline",
        "notActive": "Não Ativado",
        "search": "Por favor, insira palavras-chave",
        "batchOperation": "Operação em Lote",
        "allDevices": "Todos os Dispositivos",
        "deviceAttribute": "Atributos do Dispositivo",
        "selectReportDate": "Selecionar Data do Relatório",
        "inputName": "Por favor, insira o nome",
        "inputWidth": "Por favor, insira a largura",
        "inputHeight": "Por favor, insira a altura",
        "inputResolutionRatio": "Por favor, insira um número inteiro maior que 0!",
        "inputSort": "Por favor, insira a ordem",
        "serialNum": "Número de Série",
        "name": "Nome",
        "width": "Largura",
        "height": "Altura",
        "resolutionRatio": "Resolução",
        "inputResolutionRatioName": "Por favor, insira o nome da resolução",
        "sort": "Ordem",
        "personal": "Pessoal",
        "system": "Sistema",
        "type": "Tipo",
        "systemDefaultSettingUneditable": "Configurações padrão do sistema não podem ser editadas!",
        "systemDefaultSettingUnDeletable": "Configurações padrão do sistema não podem ser excluídas!",
        "newz": "Novo",
        "total": "Total",
        "totalNum": "itens",
        "strategyName": "Nome da Estratégia",
        "associatedTerminalNum": "Número de Terminais Associados",
        "createTime": "Data de Criação",
        "pleaseSelectStrategy": "Por favor, selecione uma estratégia!",
        "onlySelectOneData": "Apenas um item de dados pode ser selecionado!",
        "downloadStrategy": "Baixar Estratégia",
        "inputStrategyName": "Por favor, insira o nome da estratégia",
        "luminanceControl": "Controle de Luminosidade",
        "volumeStrategy": "Estratégia de Volume",
        "saveSuccess": "Salvo com sucesso",
        "screenAngle": "Rotação da Tela (°)",
        "startTime": "Hora de Início",
        "endTime": "Hora de Término",
        "repeat": "Repetir",
        "monday": "Segunda-feira",
        "tuesday": "Terça-feira",
        "wednesday": "Quarta-feira",
        "thursday": "Quinta-feira",
        "friday": "Sexta-feira",
        "saturday": "Sábado",
        "sunday": "Domingo",
        "everyday": "Todos os dias",
        "downloadSpeed": "Velocidade de Download",
        "inputDownloadSpeed": "Por favor, insira a velocidade de download",
        "operator": "Operação",
        "pleaseSelectDeleteData": "Por favor, selecione os dados a serem excluídos!",
        "confirmBatchDelete": "Confirmar exclusão em lote?",
        "pleaseInputName": "Por favor, insira o nome",
        "detailSetting": "Configurações Detalhadas",
        "weekPlan": "Plano Semanal",
        "specialDateSetting": "Configurações de Datas Especiais",
        "weekdayInfo": "Dia da semana é um item obrigatório!",
        "volumeInfo": "Volume é um item obrigatório!",
        "timeError": "Seleção de tempo inválida!",
        "editSuccess": "Edição realizada com sucesso!",
        "addSuccess": "Adição realizada com sucesso!",
        "addSpecialPlan": "Adicionar Plano de Estratégia Especial",
        "downloadSpeedInfo": "Velocidade de Download: (0 significa download proibido)",
        "pleaseSelectStartTime": "Por favor, selecione a hora de início",
        "pleaseSelectEndTime": "Por favor, selecione a hora de término",
        "luminanceError": "Por favor, insira um valor de luminosidade válido!",
        "defaultLuminance": "Luminosidade Padrão",
        "luminance": "Nível de Luminosidade",
        "defaultLuminanceInfo": "Luminosidade Padrão (100 = mais brilhante, 0 = mais escuro)",
        "volume": "Volume",
        "saveLuminance": "Salvar Luminosidade",
        "changeSuccess": "Alteração bem-sucedida!",
        "changeNetwork": "Trocar Rede",
        "netName": "Nome da Rede",
        "nameempty": "O nome da rede não pode estar vazio",
        "currentNetwork": "Rede Atual",
        "ipAddress": "Endereço IP",
        "dailyMode": "Modo Diário",
        "weeklyMode": "Modo Semanal",
        "turnOnTime": "Hora de Ligar",
        "turnOffTime": "Hora de Desligar",
        "startSleep": "Início da Hibernação",
        "endSleep": "Fim da Hibernação",
        "batchDelInfo": "Confirmar exclusão dos itens selecionados?",
        "timeCannotBeEmpty": "O tempo não pode estar vazio!",
        "startUp": "Ligar",
        "shutDown": "Desligar",
        "volumeSize": "Nível de Volume",
        "defaultVolume": "Volume Padrão (100 = máximo, 0 = mudo)",
        "chooseStartTime": "Por favor, selecione a hora de início",
        "chooseEndTime": "Por favor, selecione a hora de término",
        "saveVolume": "Salvar Volume",
        "screenRotationUnSaved": "Rotação da tela não salva",
        "volumeSettingUnSaved": "Configuração de volume não salva",
        "luminanceSettingUnSaved": "Configuração de luminosidade não salva",
        "confirmClosePopup": "Confirmar fechamento desta janela?",
        "volumeSettingSuccess": "Volume alterado com sucesso",
        "luminanceSettingSuccess": "Luminosidade alterada com sucesso",
        "advancedSettingUnSaved": "Configurações avançadas não salvas",
        "settingTitle": "Configurações do Terminal",
        "volumeSetting": "Configurações de Volume",
        "luminanceSetting": "Configurações de Luminosidade",
        "downloadSetting": "Configurações de Download",
        "sleepSetting": "Configurações de Hibernação",
        "onOffSetting": "Ligar/Desligar Programado",
        "screenRotation": "Rotação da Tela",
        "namingError": "Erro de nomenclatura, o nome do arquivo não pode conter espaços!",
        "deleteSuccess": "Exclusão bem-sucedida",
        "deleteFolder": "Excluir Pasta",
        "pleaseInputDeviceName": "Por favor, insira o nome do dispositivo",
        "pleaseInputDeviceId": "Por favor, insira o ID do dispositivo",
        "discoverDevice": "Descobrir Dispositivos",
        "deviceId": "ID do Dispositivo",
        "bound": "Vinculado",
        "bind": "Vincular",
        "noDevice": "Nenhum dispositivo disponível",
        "refresh": "Atualizar",
        "manualAdd": "Adicionar Manualmente",
        "deviceGroup": "Categoria de Dispositivos",
        "pleaseSelectGroup": "Por favor, selecione um grupo!",
        "deviceName": "Nome do Dispositivo",
        "goAdd": "Ir para Adicionar",
        "close": "Fechar",
        "bindCountInsufficient": "Quantidade de vinculações insuficiente, atualize a quantidade de dispositivos antes de adicionar!",
        "displayNumber": "Número de Exibição",
        "groupName": "Nome do Grupo",
        "pleaseSelectGroupName": "Por favor, preencha o nome do grupo!",
        "moveGroup": "Mover Grupo",
        "longitude": "Longitude",
        "latitude": "Latitude",
        "nationality": "Nacionalidade",
        "province": "Província",
        "city": "Cidade",
        "county": "Distrito",
        "outNetIp": "IP Externo",
        "inNetIp": "IP Interno",
        "companyName": "Nome da Empresa",
        "Info": "Detalhes",
        "android": "Android",
        "win": "Windows",
        "osVersion": "Versão do Sistema",
        "softwareVersion": "Versão do Software",
        "diskSize": "Tamanho do Disco",
        "useSize": "Espaço Usado",
        "macAddr": "Endereço MAC",
        "longitudeLatitudeInfo": "Longitude e latitude devem estar ambas vazias ou preenchidas!",
        "terminalName": "Nome do Terminal",
        "terminalGroup": "Grupo de Terminais",
        "reportJournal": "Relatar?",
        "systemVersion": "Versão do Sistema",
        "storageSpace": "Espaço de Armazenamento",
        "resolution": "Resolução",
        "runningMemory": "Memória RAM",
        "model": "Modelo",
        "registerStatus": "Status de Registro",
        "password": "Senha",
        "passwordInfo": "Por favor, insira 6 a 18 letras ou números!",
        "group": "Grupo",
        "address": "Endereço",
        "remark": "Observação",
        "renewalPeriod": "Período de Renovação",
        "money": "Valor",
        "latitudeInfo": "Por favor, insira uma latitude válida!",
        "totalPayment": "Valor Total",
        "longitudeInfo": "Por favor, insira uma longitude válida!",
        "setMeal": "Pacote",
        "number": "Quantidade",
        "programName": "Nome do Programa",
        "playStatus": "Status de Reprodução",
        "playType": "Modo de Reprodução",
        "play": "Reproduzir",
        "pause": "Pausar",
        "playTime": "Tempo de Reprodução",
        "programDeleted": "Programa excluído",
        "playSuccess": "Programa agendado para reprodução",
        "pauseSuccess": "Pausa bem-sucedida",
        "playCycle": "Reprodução em Ciclo",
        "playInsert": "Reprodução Inserida",
        "withdrawSuccess": "Retirada bem-sucedida",
        "withdrawInfo": "Por favor, selecione primeiro o programa a ser retirado!",
        "programBelong": "Programa Pertencente",
        "checkAll": "Selecionar Todos",
        "batchDel": "Excluir em Lote",
        "delConfirm": "Confirmar exclusão dos itens selecionados?",
        "check": "Selecionado",
        "noProgram": "Nenhum programa disponível",
        "details": "Detalhes",
        "screenshotFail": "Falha na captura de tela",
        "policyName": "Nome da Política",
        "terminalNum": "Número de Terminais Associados",
        "powerStrategy": "Estratégia de Energia",
        "pleaseSelectDepartment": "Por favor, selecione um departamento!",
        "screenshotControl": "Controle de Captura de Tela",
        "未激活": "Não Ativado",
        "已激活": "Ativado",
        "未绑定": "Não Vinculado",
        "已绑定": "Vinculado"
    },
    "programManage": {
        "programList": "Lista de Programas",
        "publishProgram": "Rastreamento de Publicação de Programas",
        "week1": "Segunda-feira",
        "week2": "Terça-feira",
        "week3": "Quarta-feira",
        "week4": "Quinta-feira",
        "week5": "Sexta-feira",
        "week6": "Sábado",
        "week7": "Domingo",
        "monday": "Segunda-feira",
        "tuesday": "Terça-feira",
        "wednesday": "Quarta-feira",
        "thursday": "Quinta-feira",
        "friday": "Sexta-feira",
        "saturday": "Sábado",
        "sunday": "Domingo",
        "name": "Nome",
        "preview": "Pré-visualizar",
        "playDeviceNum": "Número de Dispositivos de Reprodução",
        "copyDeviceCode": "Clique para copiar",
        "osType": "Tipo de Sistema",
        "playDate": "Data de Reprodução",
        "playWeek": "Semana de Reprodução",
        "everyday": "Todos os dias",
        "start": "De",
        "end": "Até",
        "playOperateStatusStr": "Status de Publicação",
        "playDevice": "Dispositivo de Reprodução",
        "downloadView": "Visualizar Download",
        "publisher": "Publicador",
        "publishTime": "Hora de Publicação",
        "operation": "Operação",
        "add": "Adicionar",
        "groupName": "Nome do Grupo",
        "selectDevice": "Selecionar Terminal",
        "searchDevice": "Pesquisar Terminal",
        "pleaseFillGroupName": "Por favor, preencha o nome do grupo!",
        "remarkInfo": "Observação",
        "compile": "Editar",
        "withdrawConfirm": "Confirmar retirada deste programa?",
        "confirm": "Confirmar",
        "cancel": "Cancelar",
        "withdraw": "Retirar",
        "batchWithdraw": "Retirar em Lote",
        "batchPublish": "Publicar em Lote",
        "batchDelete": "Excluir em Lote",
        "batchOperation": "Operação em Lote",
        "notUse": "Não Utilizado",
        "notChecked": "Não Avaliado",
        "notPass": "Não Aprovado",
        "delete": "Excluir",
        "publishTextLeft": "Publicado",
        "offTextLeft": "Pausado",
        "pleaseSelectProgramToMove": "Por favor, selecione o programa a ser transferido!",
        "pause": "Pausar",
        "pauseConfirm": "Confirmar pausa?",
        "play": "Reproduzir",
        "downloadUdisk": "Baixar para Pen Drive",
        "deviceList": "Lista de Dispositivos",
        "groupSelection": "Seleção de Grupo",
        "operationSuccess": "Operação bem-sucedida",
        "deleteSuccess": "Exclusão bem-sucedida",
        "selectDate": "Selecionar Data",
        "publishStatus": "Status de Publicação",
        "checkStatus": "Status de Avaliação",
        "waitAuditing": "Aguardando Avaliação",
        "auditPass": "Avaliação Aprovada",
        "auditRefuse": "Avaliação Recusada",
        "all": "Todos",
        "playStatus": "Em Reprodução",
        "playStatust": "Status de Reprodução",
        "pauseStatus": "Pausado",
        "notStartStatus": "Não Iniciado",
        "resolutionratio": "Resolução",
        "totalNum": "itens",
        "programName": "Nome do Programa",
        "playStartTime": "Hora de Início da Reprodução",
        "playEndTime": "Hora de Término da Reprodução",
        "createTime": "Data de Criação",
        "nationality": "Nacionalidade",
        "province": "Província",
        "city": "Cidade",
        "county": "Distrito",
        "address": "Endereço",
        "ip": "Endereço IP",
        "location": "Localização",
        "log": "Logs",
        "pleaseFillProgramName": "Por favor, preencha o nome do programa!",
        "selectGroup": "Selecionar Grupo",
        "startTime": "Hora de Início",
        "endTime": "Hora de Término",
        "publishCycle": "Ciclo de Publicação",
        "publishDeviceNum": "Número de Dispositivos Publicados",
        "pleaseSelectRecord": "Por favor, selecione um registro",
        "deviceName": "Nome do Terminal",
        "deviceId": "ID do Dispositivo Terminal",
        "deviceGroupIdName": "Grupo Pertencente",
        "notClassified": "Não Classificado",
        "osTypeStr": "Sistema do Terminal",
        "storageSpace": "Espaço de Armazenamento",
        "onLineStatus": "Status de Conexão",
        "onLine": "Online",
        "offLine": "Offline",
        "sleep": "Hibernando",
        "unknown": "Desconhecido",
        "registerStatus": "Status de Registro",
        "trialPeriod": "Período de Teste",
        "notActive": "Não Ativado",
        "active": "Ativado",
        "parameterError": "Parâmetros inválidos!",
        "pleaseSelectProgram": "Por favor, selecione um programa!",
        "pleaseSelectProgramEdit": "Por favor, selecione o programa a ser editado!",
        "confirmWithdrawSelectedProgram": "Confirmar retirada dos programas selecionados?",
        "withdrawSuccess": "Retirada bem-sucedida",
        "allPrograms": "Todos os Programas",
        "defaultGroup": "Grupo Padrão",
        "cannotShareEmptyProgram": "Não é possível compartilhar um programa vazio!",
        "onlyShareYourProgram": "Apenas pode compartilhar programas criados por você!",
        "pleaseSelectProgramEditPublishTime": "Por favor, selecione o programa com horário de publicação editado!",
        "pleaseSelectDevice": "Por favor, selecione um dispositivo!",
        "programDetail": "Detalhes do Programa",
        "errorReason": "Motivo do Erro",
        "availableStorageSpaceInsufficient": "Espaço de armazenamento disponível insuficiente",
        "partialDeviceReleaseFailure": "Falha na publicação em dispositivos parciais",
        "allDeviceReleaseSuccess": "Publicação bem-sucedida em todos os dispositivos",
        "partialDeviceReleaseSuccess": "Publicação bem-sucedida em dispositivos parciais",
        "allGroup": "Todos os Grupos",
        "allProgram": "Todos os Programas",
        "unGrouped": "Não Agrupado",
        "replaceProgram": "Substituir Programa",
        "replaceProgramTip": "O novo programa publicado substituirá os dados dos programas existentes no terminal de reprodução!",
        "screen": "Tela Única/Dupla",
        "singleScreen": "Tela Única",
        "doubleScreen": "Tela Dupla",
        "playSetting": "Configurações de Reprodução",
        "batchPlaySetting": "Configurar Horário de Reprodução em Lote",
        "individualPlaySetting": "Configurar Horário de Reprodução Individualmente",
        "playTime": "Horário de Reprodução",
        "daily": "Diariamente",
        "weekdays": "Segunda a Sexta",
        "monthly": "Este Mês",
        "advancedSetting": "Configurações Avançadas",
        "playProgram": "Reproduzir Programa",
        "searchProgram": "Por favor, insira palavras-chave",
        "shareAddressNotExist": "Endereço de link não existe, tente novamente",
        "copySuccess": "Copiado com sucesso",
        "shareLink": "Link de Compartilhamento",
        "publish": "Publicar",
        "noResource": "Nenhum recurso disponível",
        "single": "Tela Única",
        "double": "Tela Dupla",
        "time": "Tempo",
        "associatedTerminalNum": "Número de Terminais Associados",
        "default": "Padrão",
        "moveGroup": "Mover Grupo",
        "pleaseSelectGroup": "Por favor, preencha o nome do grupo!",
        "copy": "Copiar",
        "FUBEN": "Cópia",
        "nameempty": "O nome não pode estar vazio",
        "whitespace": "Erro de nomenclatura, o nome do arquivo não pode conter espaços!",
        "programWhitespace": "Erro de nomenclatura, o nome do programa não pode conter espaços!",
        "pleaseSelectResolution": "Por favor, selecione a resolução!",
        "dataError": "Dados inválidos!",
        "createProgram": "Criar Novo Programa",
        "directCreate": "Criar Diretamente",
        "myTemplate": "Meus Modelos",
        "use": "Usar",
        "free": "Gratuito",
        "loadMore": "Carregar Mais",
        "confirmDelete": "Confirmar Exclusão",
        "deleteGroup": "Excluir Grupo",
        "notPublished": "Não Publicado",
        "notPassed": "Não Aprovado",
        "notUsed": "Não Utilizado",
        "confirmDeleteSelectedProgram": "Confirmar exclusão dos programas selecionados?",
        "companyName": "Nome da Empresa",
        "programCannotDownload": "Este programa não pode ser baixado!",
        "publishMaterial": "Publicar Material",
        "playMaterial": "Reproduzir Material",
        "pleaseInputMaterialName": "Por favor, insira o nome do material",
        "size": "Tamanho",
        "pleaseInputDeviceName": "Por favor, insira o nome do dispositivo",
        "item": "itens",
        "allMaterial": "Todos os Materiais",
        "allDevices": "Todos os Dispositivos", "saveSuccess": "Salvo com sucesso",
        "savefaill": "Falha ao salvar",
        "playMode": "Modo de reprodução",
        "cyclePlay": "Reprodução cíclica",
        "insertPlay": "Reprodução inserida",
        "noData": "Nenhum dado disponível",
        "Add": "Adicionar",
        "replace": "Substituir",
        "repeat": "Repetir",
        "start01": "Início",
        "end01": "Fim",
        "startDate": "Data de início",
        "endDate": "Data de fim",
        "useNow": "Usar imediatamente",
        "fillStartEndTimeFirst": "Preencha primeiro o horário de início e fim antes de adicionar",
        "fillFullPlayTime": "Preencha a duração completa de reprodução",
        "fillCorrectPlayTime": "Preencha o período de reprodução correto",
        "sDateAndEDateBothEmptyOrFilled": "A data de início e a data de fim devem estar ambas vazias ou ambas preenchidas"
    },
    "source": {
        "addResource": "Adicionar recurso",
        "width": "Largura",
        "height": "Altura",
        "size": "Tamanho (KB)",
        "name": "Nome",
        "pleaseInputResourceName": "Por favor, insira o nome do recurso!",
        "addToGroup": "Adicionar ao grupo",
        "remark": "Observação",
        "promptFgIllustrate": "Ilustração",
        "promptFgRealisticPhoto": "Foto realista",
        "promptFgSimplisticDrawing": "Desenho simples",
        "promptFgChineseStyle": "Estilo chinês",
        "promptFgPixelArt": "Arte pixel",
        "noModel": "Nenhum modelo disponível, entre em contato com o administrador!",
        "getModelFailed": "Falha ao obter o modelo, tente novamente mais tarde! Ou entre em contato com o administrador!",
        "createImagePrompt": "Gerando imagem, não feche a janela por favor!",
        "promptEmpty": "Por favor, insira o prompt",
        "dpiEmpty": "Por favor, selecione a proporção da imagem!",
        "fgEmpty": "Por favor, selecione o estilo!",
        "style": "Estilo",
        "idEmpty": "O ID da imagem não pode estar vazio",
        "exist": "Esta imagem já existe nos materiais",
        "addSuccess": "Material adicionado com sucesso",
        "saveError": "Falha ao salvar a imagem, tente novamente mais tarde!",
        "delSuccess": "Exclusão bem-sucedida",
        "generateImage": "Texto para imagem",
        "generateImagePlaceholder": "Insira o que deseja gerar, ex: Uma borboleta dançando em um campo de flores",
        "aiExpand": "Expansão inteligente",
        "negativePrompt": "Prompt negativo",
        "negativePromptTooltip": "Usado para excluir explicitamente conteúdo ou características que o usuário não deseja que apareçam na saída",
        "imageRatio": "Proporção da imagem",
        "generateImageBtn": "Gerar imediatamente",
        "shengchengjieguo": "Resultado da geração",
        "generateImageLoadingTip": "Gerando, não clique repetidamente nem feche a janela...",
        "Tooltip": "Venha dar vida à sua criatividade com IA!",
        "saveToMaterial": "Salvar em materiais",
        "publish": "Publicar imediatamente",
        "download": "Baixar",
        "generateHistory": "Histórico de gerações",
        "hide": "Recolher",
        "cancel": "Cancelar",
        "useExpand": "Usar expansão",
        "all": "Todos",
        "delete": "Excluir",
        "loadMore": "Carregar mais",
        "aiTip": "O conteúdo é gerado por um modelo de inteligência artificial e não representa os pontos de vista, posições ou atitudes da plataforma. Por favor, use o conteúdo de IA de forma legal e adequada.",
        "operationSuccess": "Operação bem-sucedida",
        "moveGroup": "Mover grupo",
        "groupName": "Nome do grupo",
        "pleaseSelectGroup": "Por favor, selecione o nome do grupo!",
        "shenhe": "Avaliação",
        "shenheStatus": "Status da avaliação",
        "shenheSuccess": "Avaliação aprovada",
        "shenheRefuse": "Avaliação recusada",
        "pleaseSelectShenheStatus": "Por favor, selecione o status da avaliação!",
        "shenheRemark": "Observação da avaliação",
        "pleaseInputShenheRemark": "Por favor, insira a observação da avaliação!",
        "pleaseInputFileName": "Por favor, insira o nome do arquivo!",
        "whitespace": "Erro de nomenclatura, o nome do arquivo não pode conter espaços!",
        "dataError": "Dados incorretos!",
        "confirmDelete": "Confirmar exclusão",
        "confirm": "Confirmar",
        "deleteFolder": "Excluir pasta",
        "add": "Adicionar",
        "edit": "Editar",
        "fileName": "Nome do arquivo",
        "group": "Grupo",
        "resolution": "Resolução",
        "type": "Tipo",
        "image": "Imagem",
        "music": "Música",
        "video": "Vídeo",
        "uploadTime": "Hora do upload",
        "uploadUser": "Usuário que fez o upload",
        "checkTime": "Hora da avaliação",
        "checkUser": "Usuário que avaliou"
    },
    "setting": {
        "nameempty": "O nome não pode estar vazio",
        "heightempty": "A altura não pode estar vazia",
        "widthempty": "A largura não pode estar vazia",
        "resolutionratio": "Resolução",
        "name": "Nome",
        "opteration": "Operação",
        "compile": "Editar",
        "delete": "Excluir",
        "newz": "Novo",
        "compileratio": "Editar resolução",
        "sheizhifenbianlvmingcheng": "Definir nome da resolução",
        "shezhigaodu": "Definir altura",
        "shezhikuandu": "Definir largura",
        "xinzengfenbianlv": "Adicionar resolução",
        "bianma": "Codificação",
        "bianjizhongduanmingcheng": "Editar nome do terminal",
        "xinzengzhongduan": "Adicionar terminal",
        "selectPrimaryColor": "Selecionar cor tema",
        "fullScreen": "Tela cheia",
        "exitFullScreen": "Sair da tela cheia"
    },
    "tabs": {
        "refresh": "Atualizar",
        "refreshAll": "Atualizar tudo",
        "close": "Fechar",
        "closeOthers": "Fechar outros",
        "closeAll": "Fechar todos",
        "closeLeft": "Fechar à esquerda",
        "closeRight": "Fechar à direita"
    },
    "errorPage": {
        "needLogin": "Você ainda não fez login!",
        "pageNotFound": "A página que você está tentando acessar não existe!",
        "redirectTo": "Redirecionar para",
        "orReturn": "ou retornar para",
        "previousStep": "Passo anterior"
    },
    "headerUs": {
        "systemNotice": "Notificação do sistema",
        "allNotices": "Todas as notificações",
        "viewAllMessages": "Ver todas as mensagens",
        "contactUs": "Entre em contato conosco",
        "operationSuccess": "Operação bem-sucedida!",
        "leaveMessage": "Deixar uma mensagem",
        "messageTitle": "Título",
        "messageTitleTip": "Por favor, insira o título!",
        "messageContentTip": "Máximo 150 caracteres",
        "submit": "Enviar",
        "markAsRead": "Marcar como lido",
        "success": "Operação bem-sucedida!"
    },
    "material": {
        "allMaterial": "Todos os materiais",
        "defaultGroup": "Grupo padrão",
        "auditStatus": "Status da avaliação",
        "auditPassed": "Avaliação aprovada",
        "auditRejected": "Avaliação recusada",
        "pendingAudit": "Pendente de avaliação",
        "all": "Todos",
        "operateSuccess": "Operação bem-sucedida!",
        "pleaseSelectMaterial": "Por favor, selecione materiais!",
        "moveGroup": "Mover grupo",
        "pleaseSelectGroup": "Por favor, selecione um grupo!",
        "batchPublish": "Publicar em lote",
        "batchRecall": "Recuperar em lote",
        "batchDelete": "Excluir em lote",
        "materialList": "Lista de materiais",
        "uploadMaterial": "Fazer upload de materiais",
        "materialType": "Tipo de material",
        "pleaseInputMaterialName": "Por favor, insira o nome do material",
        "selectAll": "Selecionar tudo",
        "confirmDeleteSelectedMaterial": "Confirmar exclusão dos materiais selecionados?",
        "deleteSuccess": "Exclusão bem-sucedida",
        "delete": "Excluir",
        "publish": "Publicar",
        "recall": "Recuperar",
        "confirmRecallSelectedMaterial": "Confirmar recuperação dos materiais selecionados?",
        "pleaseSelectMaterialGroup": "Por favor, selecione o grupo de materiais!",
        "recallSuccess": "Recuperação bem-sucedida",
        "publishSuccess": "Publicação bem-sucedida",
        "batchOperate": "Operação em lote",
        "item": "itens",
        "confirmDelete": "Confirmar exclusão?",
        "edit": "Editar",
        "confirmRecall": "Confirmar recuperação?",
        "unaudited": "Não avaliado",
        "notPassed": "Não aprovado",
        "operate": "Operação",
        "resolution": "Resolução",
        "none": "Nenhum",
        "confirm": "Confirmar",
        "cancel": "Cancelar",
        "AICreation": "Criação IA"
    },
    "uploadFile": {
        "operationSuccess": "Operação bem-sucedida",
        "uploadFile": "Gerenciamento de upload",
        "uploadSuccess": "Upload bem-sucedido",
        "uploadCompleted": "Upload concluído",
        "uploadFail": "Falha no upload",
        "ConversionFailed": "Falha na conversão!",
        "loading": "Carregando intensamente...",
        "beQueuing": "Na fila...",
        "Uploading": "Fazendo upload...",
        "ConversionIng": "Convertendo...",
        "ConventionalResources": "Recursos convencionais",
        "DocumentResources": "Recursos de documentos",
        "complete": "Concluído",
        "upload": "Fazer upload",
        "fileSizeWraning01": "O tamanho do material excede",
        "fileSizeWraning02": "Por favor, modifique e faça upload novamente!",
        "fileIsEmpty": "O arquivo está vazio",
        "uploadFileTip": "Formato de arquivo não suportado",
        "unablePreview": "Não foi adicionado com sucesso à biblioteca de materiais, não é possível visualizar",
        "confirmDelete": "Confirmar exclusão?",
        "deleteSuccess": "Exclusão bem-sucedida",
        "delete": "Excluir",
        "confirm": "Confirmar",
        "preview": "Visualizar",
        "close": "Fechar",
        "cancel": "Cancelar",
        "fileType": "Tipo de arquivo",
        "fileSize": "Tamanho do arquivo",
        "conversionProgress": "Progresso da conversão",
        "progress": "Progresso",
        "image": "Imagem",
        "video": "Vídeo",
        "audio": "Música",
        "limitTip01": "Fazer upload de",
        "limitTip02": "arquivos de uma vez",
        "okTip": "Fazendo upload de materiais, não feche a janela por favor!",
        "usableSize": "Capacidade disponível",
        "sizeUnableTip": "A capacidade de armazenamento disponível atual é insuficiente. Por favor, limpe os materiais inúteis em tempo hábil para economizar espaço ou entre em contato com o distribuidor para expandir a capacidade de armazenamento em nuvem. Este serviço pode gerar custos, consulte as informações do distribuidor para mais detalhes.",
        "view": "Ver detalhes",
        "fileName": "Nome do arquivo"
    },
    "template": {
        "inputPlaceholder": "Por favor, insira",
        "selectPlaceholder": "Por favor, selecione",
        "noAuths": "Sem permissões, entre em contato com o administrador",
        "operationSuccess": "Operação bem-sucedida",
        "total": "Total",
        "totalNum": "itens",
        "dan": "Simples",
        "shaung": "Duplo",
        "pleaseSelectGroup": "Por favor, selecione um grupo",
        "preview": "Visualizar",
        "free": "Gratuito",
        "use": "Usar",
        "dpi": "Resolução",
        "delete": "Excluir",
        "confirmDelete": "Confirmar exclusão",
        "confirmDeleteSelectedTemplate": "Confirmar exclusão desta modelo?",
        "push": "Publicar",
        "pushConfirm": "Confirmar publicação em modelos públicos?",
        "pushRemovalConfirm": "Confirmar retirada dos modelos públicos?",
        "templateOrderRecord": "Registro de pedidos de modelos",
        "unpublished": "Não publicado",
        "auditing": "Em avaliação",
        "publishRejected": "Publicação recusada",
        "publishSuccess": "Publicação bem-sucedida",
        "offShelf": "Retirar do catálogo",
        "公共模版": "Modelos públicos",
        "我的模板": "Meus modelos",
        "共享记录": "Registro de compartilhamento",
        "name": "Nome",
        "pubdate": "Data de publicação",
        "keySeachTip": "Por favor, insira palavras-chave",
        "allGroup": "Todos os grupos",
        "add": "Adicionar",
        "edit": "Editar",
        "programName": "Nome do programa",
        "selectGroup": "Selecionar grupo"
    },
    "checkManage": {
        "total": "Total",
        "totalNum": "itens",
        "operationSuccess": "Operação bem-sucedida",
        "checkUserLogs": "Registro de avaliações (Operador)",
        "checkLogs": "Registro de avaliações (Avaliador)",
        "sourceCheck": "Avaliação de materiais",
        "programCheck": "Avaliação de programas",
        "checkAll": "Selecionar tudo",
        "auditPass": "Avaliação aprovada",
        "auditRefuse": "Avaliação recusada",
        "auditPass01": "Aprovado",
        "auditRefuse01": "Recusado",
        "auditRefuse02": "Recusar avaliação",
        "auditor": "Avaliador",
        "agentUserName": "Publicador",
        "interrogationTime": "Hora da solicitação de avaliação",
        "checkTime": "Hora da avaliação",
        "checkName": "Nome da avaliação",
        "checkType": "Categoria da avaliação",
        "checkIp": "Endereço IP da solicitação de avaliação",
        "checkReason": "Comentário",
        "checkStatus": "Conteúdo da operação",
        "rangePicker": "Data da avaliação",
        "keyWord": "Palavra-chave",
        "all": "Todos",
        "program": "Programa",
        "material": "Material",
        "dan": "Simples",
        "shaung": "Duplo",
        "pleaseSelectProgram": "Por favor, selecione um programa!",
        "pleaseSelectMaterial": "Por favor, selecione materiais!",
        "preview": "Visualizar",
        "dpi": "Resolução",
        "auditRefuseTip": "Por favor, insira o motivo da recusa",
        "unreviewed": "Não avaliado",
        "notPassed": "Não aprovado",
        "notUsed": "Não utilizado",
        "edit": "Editar",
        "none": "Nenhum",
        "name": "Nome",
        "size": "Tamanho",
        "type": "Tipo",
        "uploadTime": "Hora do upload",
        "uploadUser": "Usuário que fez o upload",
        "checkUser": "Avaliador",
        "image": "Imagem",
        "music": "Música",
        "video": "Vídeo"
    },
    "systemSet": {
        "total": "Total",
        "totalNum": "itens",
        "inputPlaceholder": "Por favor, insira",
        "selectPlaceholder": "Por favor, selecione",
        "userList": "Membros da organização",
        "roleList": "Permissões de cargo",
        "department": "Estrutura organizacional",
        "diskInfo": "Espaço de armazenamento",
        "approveSet": "Aprovação de conteúdo",
        "logList": "Gerenciamento de logs",
        "name": "Nome",
        "account": "Conta",
        "userName": "Nome do usuário",
        "phoneNumber": "Número de telefone",
        "role": "Cargo",
        "createTime": "Hora de criação",
        "operation": "Operação",
        "edit": "Editar",
        "delete": "Excluir",
        "addNew": "Novo",
        "add": "Adicionar",
        "resetPassword": "Redefinir senha",
        "confirmDelete": "Confirmar exclusão",
        "departmentOrganization": "Organização de departamentos",
        "addNewUser": "Adicionar novo usuário",
        "pleaseEnterUserName": "Por favor, insira o nome do usuário",
        "confirmPasswordNotMatch": "A senha de confirmação não corresponde à senha inserida!",
        "operationSuccess": "Operação bem-sucedida!",
        "userNickname": "Nome de usuário",
        "pleaseEnterUserNickname": "Por favor, insira o nome de usuário",
        "userNicknameRequired": "O nome de usuário não pode estar vazio!",
        "password": "Senha",
        "pleaseEnterPassword": "Por favor, insira a senha",
        "passwordRequired": "A senha não pode estar vazia!",
        "passwordTip": "Sua senha é muito insegura (deve conter pelo menos 3 dos seguintes tipos: letras maiúsculas, letras minúsculas, números, caracteres especiais e ter um comprimento de 8",
        "confirmPassword": "Confirmar senha",
        "pleaseEnterPhoneNumber": "Por favor, insira o número de telefone",
        "phoneNumberRequired": "O número de telefone não pode estar vazio!",
        "phoneNumberFormatError": "Por favor, insira um número de telefone válido!",
        "roleRequired": "O cargo não pode estar vazio!",
        "required": "Não pode estar vazio!",
        "departmentName": "Departamento",
        "modifyPassword": "Modificar senha",
        "newPassword": "Nova senha",
        "pleaseEnterNewPassword": "Por favor, insira a nova senha",
        "pwdMessage": "A senha deve ter entre 8 e 20 caracteres, não pode conter espaços e deve incluir 3 dos seguintes tipos: letras maiúsculas, letras minúsculas, números, caracteres especiais",
        "all": "Todos",
        "noAuths": "Sem permissões, entre em contato com o administrador",
        "departmentName01": "Nome do departamento",
        "image": "Imagem",
        "music": "Música",
        "video": "Vídeo",
        "buySize": "Quantidade comprada",
        "totalMoney": "Valor pago",
        "buycreateTime": "Hora da compra",
        "endTime": "Data de vencimento",
        "buyTypeStr": "Tipo de pedido",
        "sourceCheck": "Avaliação de materiais",
        "programCheck": "Avaliação de programas",
        "programName": "Nome do programa",
        "diskExpansion": "Recomenda-se limpar os materiais vencidos/não utilizados em tempo hábil durante o uso para garantir a capacidade disponível do sistema. Se precisar de mais espaço, pode entrar em contato com seu fornecedor de equipamentos para obter o serviço de expansão de capacidade de armazenamento em nuvem. Este serviço pode gerar custos, consulte as informações do distribuidor para mais detalhes.",
        "selectPermission": "Por favor, selecione permissões",
        "checkPermission": "Por favor, marque as permissões",
        "addRole": "Adicionar cargo",
        "enterRoleName": "Por favor, insira o nome do cargo",
        "roleName": "Nome do cargo",
        "roleNameRequired": "O nome do cargo não pode estar vazio!",
        "remark": "Observação",
        "enterRemark": "Por favor, insira uma observação",
        "permissionSetting": "Configuração de permissões",
        "deleteSuccess": "Exclusão bem-sucedida!",
        "confirmToDelete": "Confirmar exclusão?",
        "orgName": "Nome da organização",
        "orgNameRequired": "O nome da organização não pode estar vazio!",
        "orgRemark": "Observação da organização",
        "enterOrgRemark": "Por favor, insira uma observação da organização",
        "capacityUsage": "Uso da capacidade",
        "usedCapacity": "Capacidade utilizada",
        "totalCapacity": "Capacidade total",
        "remainingCapacity": "Capacidade restante",
        "capacityExpansion": "Expansão de capacidade",
        "enable": "Ativar",
        "disable": "Desativar",
        "userName01": "Nome de usuário",
        "loginTime": "Hora do login",
        "ipAddress": "Endereço IP",
        "loginResult": "Resultado do login",
        "selectDate": "Selecionar data",
        "enterDate": "Por favor, selecione uma data",
        "selectStartTime": "Por favor, selecione a hora de início",
        "selectEndTime": "Por favor, selecione a hora de término",
        "enterUserName": "Por favor, insira o nome de usuário",
        "userCount": "Número de usuários",
        "roleDesc": "Descrição do cargo",
        "roleAuthorization": "Autorização de cargo",
        "success": "Sucesso",
        "failure": "Falha",
        "time": "Tempo",
        "operationContent": "Conteúdo da operação",
        "playCount": "Número de reproduções",
        "playDuration": "Duração da reprodução",
        "selectDevice": "Selecionar dispositivo",
        "enterProgramName": "Por favor, insira o nome do programa",
        "serialNumber": "Número de série",
        "publishContentName": "Nome do conteúdo publicado",
        "playMode": "Modo de reprodução",
        "cyclePlay": "Reprodução cíclica",
        "insertPlay": "Reprodução inserida",
        "paddingPlay": "Reprodução de preenchimento",
        "playDeviceId": "ID do dispositivo de reprodução",
        "playDeviceName": "Nome do dispositivo de reprodução",
        "publishTime": "Hora da publicação",
        "downloadStatus": "Status do download",
        "notDownloaded": "Não baixado",
        "downloading": "Baixando",
        "downloadSucceeded": "Download bem-sucedido",
        "downloadFailed": "Falha no download",
        "enterPublishContentName": "Por favor, insira o nome do conteúdo publicado",
        "terminalId": "ID do terminal",
        "belongOrg": "Organização à qual pertence",
        "reportTime": "Hora do relatório",
        "reportIp": "IP do relatório",
        "logInfo": "Informações do log",
        "details": "Detalhes",
        "confirmDeletion": "Confirmar exclusão?",
        "logDetails": "Detalhes do log",
        "download": "Baixar",
        "deptOrg": "Organização de departamentos",
        "query": "Consultar",
        "queryByTerminalId": "Consultar por ID do terminal",
        "batchDeleteLogs": "Excluir logs em lote",
        "customTimeDeleteLogs": "Excluir logs em horário personalizado",
        "selectTimeRangeFirst": "Por favor, selecione primeiro um intervalo de tempo",
        "deleteAllDeviceLogsIfEmpty": "Se não inserir o ID do dispositivo, os logs de todos os dispositivos serão excluídos por padrão",
        "enterDeviceIdToDeleteLogs": "Por favor, insira o ID do dispositivo cujos logs deseja excluir",
        "confirmDeleteAction": "Confirmar exclusão",
        "selectDeleteRangeFirst": "Por favor, selecione primeiro o intervalo de exclusão",
        "networkConnectionFailed": "Falha na conexão de rede",
        "playLog": "Log de reprodução",
        "publishLog": "Log de publicação",
        "errorLog": "Log de erros",
        "operationLog": "Log de operações",
        "fileLog": "Log de arquivos",
        "userOperateLog": "Log de login"
    },
    "userManual": {
        "userManual": "Manual do usuário",
        "noData": "Nenhum dado disponível"
    },
    "systemNotice": {
        "systemNotice": "Notificação do sistema",
        "noData": "Nenhum dado disponível",
        "total": "Total",
        "totalNum": "itens",
        "markAllRead": "Marcar tudo como lido",
        "deleteAll": "Excluir tudo",
        "all": "Todos",
        "unread": "Não lido",
        "read": "Lido",
        "type": "Tipo",
        "content": "Conteúdo",
        "date": "Data",
        "status": "Status",
        "confirmDelete": "Confirmar exclusão?",
        "confirm": "Confirmar",
        "cancel": "Cancelar",
        "delete": "Excluir"
    }
};